import { BellIcon, BookmarkIcon, CalendarDaysIcon, FlameIcon, HeadsetIcon, HouseIcon, LayersIcon, LayoutGridIcon, SearchIcon, SparklesIcon, TrophyIcon, UserRoundIcon, UsersIcon } from "lucide-react";
import type { MobileNavigationItem } from "@animeshadow/shared";

export const NAVIGATION_ITEMS = {
  home: { label: "Главная", short: "Главная", icon: HouseIcon, to: "/", private: false },
  catalog: { label: "Каталог", short: "Каталог", icon: LayoutGridIcon, to: "/browse", private: false },
  search: { label: "Поиск", short: "Поиск", icon: SearchIcon, to: "/browse", private: false },
  schedule: { label: "Расписание", short: "График", icon: CalendarDaysIcon, to: "/schedule", private: false },
  profile: { label: "Профиль", short: "Профиль", icon: UserRoundIcon, to: "/profile", private: true },
  library: { label: "Мой список", short: "Список", icon: BookmarkIcon, to: "/library", private: true },
  notifications: { label: "Уведомления", short: "Серии", icon: BellIcon, to: "/library#new-episodes", private: true },
  rooms: { label: "Комнаты", short: "Комнаты", icon: UsersIcon, to: "/party", private: false },
  collections: { label: "Подборки", short: "Подборки", icon: LayersIcon, to: "/collections", private: false },
  ongoing: { label: "Онгоинги", short: "Онгоинги", icon: FlameIcon, to: "/ongoing", private: false },
  top: { label: "Топ аниме", short: "Топ", icon: TrophyIcon, to: "/top", private: false },
  recommendations: { label: "Рекомендации", short: "Для тебя", icon: SparklesIcon, to: "/recommendations", private: true },
  support: { label: "Поддержка", short: "Помощь", icon: HeadsetIcon, to: "/contact", private: false },
} satisfies Record<MobileNavigationItem, { label: string; short: string; icon: typeof HouseIcon; to: string; private: boolean }>;

export function navigationActive(pathname: string, items: MobileNavigationItem[]): MobileNavigationItem | null {
  return items.find((id) => {
    if (id === "notifications" || id === "search") return false;
    const path = NAVIGATION_ITEMS[id].to;
    return path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(`${path}/`);
  }) ?? null;
}
